import React, { Fragment, useState } from 'react'
import { Row, Col, Button } from 'reactstrap'
import { connect } from 'react-redux'
import queryString from 'query-string'

import { notificationDanger } from '../../../utils/customToastify'
import { getDuplicates } from '../redux/tsDealersActions'
import { closeModal } from '../../../common/GlobalModal/redux/GlobalModalActions'
import Loader from '../../Loader/BasicLoader'
import CustomNumberFormat from '../../../common/CustomNumberFormat'
import CustomInput from '../../../common/InputGroup'
import camelToSnake from '../../../utils/camelToSnake'

const AddNewTSDealer = ({ getDuplicates, closeModal, history }) => {
  const [tsDealerData, setTsDealerData] = useState({
    name: '',
    businessPhone: '',
    addressZip: '',
  })
  const [isLoading, setIsLoading] = useState(false)
  const [errors, setErrors] = useState({})

  const onChange = (e) => {
    const { value, name } = e.target
    setTsDealerData({ ...tsDealerData, [name]: value })
    // Clear a field's error as soon as the user edits it.
    setErrors((prev) => ({ ...prev, [name]: '' }))
  }

  // Required fields (addressZip is optional). A `return` inside forEach only exits
  // that iteration, so the old check just warned but let onSave carry on and
  // create the dealer anyway — validate here, show messages under the inputs, abort.
  const REQUIRED_FIELDS = { name: 'Name', businessPhone: 'Business Phone' }

  const onSave = async () => {
    const nextErrors = {}
    Object.keys(REQUIRED_FIELDS).forEach((key) => {
      if (!`${tsDealerData[key] || ''}`.trim()) nextErrors[key] = `${REQUIRED_FIELDS[key]} is required.`
    })
    if (Object.keys(nextErrors).length) {
      setErrors(nextErrors)
      return
    }
    setErrors({})
    setIsLoading(true)
    const snakedData = {}
    Object.keys(tsDealerData).forEach((key) => {
      snakedData[camelToSnake(key)] = tsDealerData[key]
    })
    const responseDuplicates = await getDuplicates(snakedData)
    setIsLoading(false)
    if (responseDuplicates.length > 0) {
      notificationDanger('Duplicate. This dealer is already created.')
    } else {
      closeModal('add_ts_dealer')
      const stringifyedData = queryString.stringify(tsDealerData)
      history.push(`/ts-dealers/add?${stringifyedData}`)
    }
  }

  let loader = null
  if (isLoading) loader = <Loader />

  return (
    <Fragment>
      {loader}
      <Row className='mb-3'>
        <Col>
          <CustomInput
            onChange={onChange}
            name='name'
            label='Name'
            value={tsDealerData.name}
            placeholder='Name'
            type='text'
            invalid={Boolean(errors.name)}
            errorMess={errors.name}
          />
        </Col>
      </Row>
      <Row className='mb-3'>
        <Col>
          <CustomNumberFormat
            label='Phone Number'
            className={'form-control-sm form-control'}
            name='businessPhone'
            value={tsDealerData.businessPhone}
            placeholder='Business Phone'
            type='tel'
            format='(999) 999-9999'
            onChange={onChange}
            size={10}
            hidePhoneIcon
            invalid={Boolean(errors.businessPhone)}
          />
          {/* CustomNumberFormat uses PrimeReact InputMask (no Bootstrap is-invalid),
              so its FormFeedback won't show — render the message ourselves. */}
          {errors.businessPhone && <small className='text-danger'>{errors.businessPhone}</small>}
        </Col>
      </Row>
      <Row className='mb-3'>
        <Col>
          <CustomInput
            onChange={onChange}
            name='addressZip'
            label='Zip Code'
            value={tsDealerData.addressZip}
            placeholder='Zip Code'
            type='text'
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <hr />
        </Col>
      </Row>
      <Row>
        <Col>
          <Button
            className='float-right ml-2'
            color='danger'
            size='sm'
            block={false}
            onClick={() => closeModal('add_ts_dealer')}
          >
            Cancel
          </Button>
          <Button className='gold-color-button float-right' size='sm' block={false} onClick={onSave}>
            Save
          </Button>
        </Col>
      </Row>
    </Fragment>
  )
}

export default connect(null, { getDuplicates, closeModal })(AddNewTSDealer)
